import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { createFileRoute } from '@tanstack/react-router';
import { MessageSquare } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/org-settings/communication')({
    staticData: {
        metadata: {
            title: 'Communication',
        },
        ui: {
            icon: MessageSquare,
            title: 'Communication',
            subtitle: 'Manage communication templates and email signatures',
            useTitleForChildren: true,
            menuDescription: 'Manage communication templates and email signatures',
        },
        // Compliance uses org templates too (complaint acknowledgements and communications).
        modules: ['claim', 'compliance'],
        permissions: ['settings:update'],
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ConfigurationCommunication />
        </PageController>
    );
}

function ConfigurationCommunication() {
    return (
        <Tabs
            items={[
                {
                    label: 'Templates',
                    to: '/console/$orgId/configuration/org-settings/communication/comm-templates',
                },
                {
                    label: 'Email signatures',
                    to: '/console/$orgId/configuration/org-settings/communication/comm-signatures',
                },
            ]}
        />
    );
}
